import { ButtonIcon, Caption, css, EditIcon, styled } from 'canoe';
import React from 'react';

import { useWorkspacePath } from 'commons/hooks';
import { STYLEGUIDE_PATH } from 'dashboard/pages/Styleguide';

const Section = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spaces.s};
  `}
`;

const SectionHeader = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${theme.colors.GlitterGrayD10};
    padding: ${theme.spaces.xxs} 0;
  `}
`;

const Label = styled(Caption)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.OnyxGrayD20};
    margin: 0;
  `}
`;

interface Props {
  children: React.ReactNode;
  expandedByDefault?: boolean;
  label: string;
  anchor?: string;
  styleguideSection?: string;
}

export const TabSection = ({ children, label, styleguideSection, anchor }: Props) => {
  const workspacePath = useWorkspacePath();

  return (
    <Section className={anchor}>
      <SectionHeader>
        <Label>{label}</Label>
        {styleguideSection && (
          <ButtonIcon
            icon={EditIcon}
            color="contrast"
            size="xsmall"
            onClick={() =>
              window.open(workspacePath(`${STYLEGUIDE_PATH}/${styleguideSection}`), '_blank')
            }
          />
        )}
      </SectionHeader>
      {children}
    </Section>
  );
};
